// extracted by mini-css-extract-plugin
export default {"Holidays":"Holidays_Holidays__L13XU","HolidaysDivider":"Holidays_HolidaysDivider__6E7jS","HolidaysItems":"Holidays_HolidaysItems__w1E2X"};